const vAr = {
  badge: "شارة",
  open: "Open",
  close: "إغلاق",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "لم يتم إيجاد نتائج",
    loadingText: "يتم جلب العناصر..."
  },
  dataTable: {
    itemsPerPageText: "عدد الصفوف لكل صفحة:",
    ariaLabel: {
      sortDescending: "مرتب تنازلياً.",
      sortAscending: "مرتب تصاعدياً.",
      sortNone: "غير مرتب.",
      activateNone: "نشط لإزالة الترتيب.",
      activateDescending: "نشط للترتيب تنازلياً.",
      activateAscending: "نشط للترتيب تصاعدياً."
    },
    sortBy: "رتب حسب"
  },
  dataFooter: {
    itemsPerPageText: "عدد العناصر لكل صفحة:",
    itemsPerPageAll: "الكل",
    nextPage: "الصفحة التالية",
    prevPage: "الصفحة السابقة",
    firstPage: "الصفحة الأولى",
    lastPage: "الصفحة الأخيرة",
    pageText: "{0}-{1} من {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    }
  },
  noDataText: "لا توجد بيانات",
  carousel: {
    prev: "المعروض السابق",
    next: "المعروض التالي",
    ariaLabel: {
      delimiter: "المعروض رقم {0} من {1}"
    }
  },
  calendar: {
    moreEvents: "{0} أكثر",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} ملفات",
    counterSize: "{0} ملفات ({1} في المجموع)"
  },
  timePicker: {
    am: "صباحاً",
    pm: "مساءً",
    title: "Select Time"
  },
  pagination: {
    ariaLabel: {
      root: "الإنتقال بين الصفحات",
      next: "الصفحة التالية",
      previous: "الصفحة السابقة",
      page: "{0} انتقل إلى الصفحة",
      currentPage: "{0} الصفحة الحالية رقمها",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "القييم {0} من {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  }
};
const en$1 = {
  badge: "Badge",
  open: "Open",
  close: "Close",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    }
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Select Time"
  },
  pagination: {
    ariaLabel: {
      root: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Go to page {0}",
      currentPage: "Page {0}, Current page",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "Rating {0} of {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  }
};
const mEn = {
  general: {
    logo: "{brand} Logo",
    tradingAccount: "{brand} Trading Account",
    logout: "Log Out",
    ago: {
      minutes: "{duration} min.",
      seconds: "{duration} sec."
    },
    search: "Search"
  },
  malarkeyLogin: {
    general: {
      login: "Log In",
      submit: "Submit",
      clear: "Clear"
    },
    fields: {
      otp: "Two-Factor Authentication Code"
    },
    agent: {
      hint: "Please log in with your {bold} agent credentials",
      mfaHint: "Please enter your {bold} Two-Factor Authentication code:",
      fields: {
        username: "{brand} Agent Username",
        password: "{brand} Agent Password"
      }
    },
    client: {
      hint: "Please log in with your {bold} credentials",
      mfaHint: "Please enter your {bold} Trading Account Two-Factor Authentication code:",
      fields: {
        username: "{brand} Trading Account Email",
        password: "{brand} Trading Account Password"
      }
    },
    errors: {
      loginSubmit: "Authentication Failed"
    },
    twoFactorDialog: {
      title: "Two-Factor Authentication",
      abbreviation: "2FA"
    }
  },
  malarkeyContactSearch: {
    noDataText: {
      unready: "Please wait for the application to finish loading",
      unauthenticated: "Please log in to search for contacts",
      disabled: "Search is currently disabled",
      searching: "No contacts match your search",
      default: "No contacts available yet. Please wait."
    }
  },
  malarkeyStartChat: {
    general: {
      start: "Chat",
      cancel: "Cancel",
      latestContacts: "Recently Updated Contacts",
      noContacts: "No contacts available"
    },
    fields: {
      participants: {
        label: "Participants",
        placeholder: "Who would you like to chat with?"
      }
    },
    title: "Start a Secured Chat",
    errors: {
      conversationSubmit: "Failed to start chat"
    }
  },
  malarkeyConversationListItem: {
    actions: {
      markAllAsRead: "Mark All as Read",
      markAllAsUnread: "Mark All as Unread",
      mute: "Mute",
      unmute: "Unmute"
    }
  },
  malarkeyChat: {
    tooltips: {
      mute: "Mute notifications",
      unmute: "Unmute notifications"
    },
    attachments: {
      file: "File",
      visual: "Photos & videos",
      audio: "Audio"
    },
    emojis: {
      smileys_people: "Smiles & People",
      animals_nature: "Animals & Nature",
      food_drink: "Food & Drink",
      activities: "Activities",
      travel_places: "Travel places",
      objects: "Objects",
      symbols: "Symbols",
      flags: "Flags",
      placeholder: "Search Emoji's",
      skinTone: "Skin tone"
    },
    actions: {
      readMore: "Read more",
      dropFileHere: "Drop file here",
      download: "Download File",
      saveAs: "Save As",
      reply: "Reply",
      react: "React",
      copy: "Copy",
      delete: "Delete",
      edit: "Edit"
    },
    info: {
      archived: "This conversation is archived. New messages cannot be sent or received.",
      edited: "Edited"
    }
  },
  malarkeyAttachmentPane: {
    title: {
      all: "Send Attachments",
      files: "Send Files",
      media: "Send Media",
      visuals: "Send Photos & Videos",
      audibles: "Send Audio"
    },
    caption: {
      placeholder: "Add a caption..."
    }
  },
  mMalarkeyAppUpdateSnackbar: {
    title: "New Update Available",
    action: "Update Now"
  },
  validation: {
    bad: "The value is not a valid {label}",
    notAFile: "Please select {label}",
    tooManyFiles: "Please select only 1 file",
    fileTooLarge: "The file you have selected is too large",
    invalidFileType: "The file you have selected is not an acceptable file type",
    fileTypeNotAccepted: "The file you have selected is not an acceptable file type",
    invalid: "Please enter your {label}",
    required: "Please enter your {label}",
    requiredSelection: "Please choose a {label}",
    requiredUpload: "Please select {label}",
    email: "Please enter a valid email address",
    min: "Your {label} must be at least {min} characters long",
    characters: "The {label} you have input contains invalid characters",
    alternatives: {
      all: "The value did not match all of the criteria",
      any: "No alternative was found to test against the input due to try criteria",
      match: "No alternative matched the input due to specific matching rules for at least one of the alternatives",
      one: "The value matched more than one alternative schema",
      types: "The provided input did not match any of the allowed types"
    },
    any: {
      custom: "Please enter a valid {label}",
      default: "Please contact support",
      failover: "Please contact support",
      invalid: "The value matched a value listed in the invalid values",
      only: "Only some values were allowed, the input didn't match any of them",
      ref: "The input is not valid",
      required: "A required value wasn't present",
      unknown: "A value was present while it wasn't expected"
    },
    array: {
      base: "{label} is required",
      excludes: "The array contains a value that is part of the exclusion list",
      includesRequiredBoth: "Some values were expected to be present in the array and are missing. This error happens when we have a mix of labeled and unlabeled schemas",
      includesRequiredKnowns: "Some values were expected to be present in the array and are missing. This error happens when we only have labeled schemas",
      includesRequiredUnknowns: "Please select some {label}",
      includes: "The value didn't match any of the allowed types for that array",
      length: "The array is not of the expected length",
      max: "The array has more elements than the maximum allowed",
      min: "The array has less elements than the minimum allowed",
      orderedLength: "Given an array.ordered(), that array has more elements than it should",
      sort: {
        base: "The array did not match the required sort order",
        mismatching: "Failed sorting the array due to mismatching item types",
        unsupported: "Failed sorting the array due to unsupported item types"
      },
      sparse: "An undefined value was found in an array that shouldn't be sparse",
      unique: "A duplicate value was found in an array",
      hasKnown: "The schema on an array.has() was not found in the array. This error happens when the schema is labeled",
      hasUnknown: "The schema on an array.has() was not found in the array. This error happens when the schema is unlabeled"
    },
    binary: {
      base: "The value is either not a Buffer or could not be cast to a Buffer from a string",
      length: "The buffer was not of the specified length",
      max: "The buffer contains more bytes than expected",
      min: "The buffer contains less bytes than expected"
    },
    boolean: {
      base: "{label} is required"
    },
    date: {
      base: "{label} is required",
      format: "The date does not match the required format",
      greater: "The date is over the limit that you set",
      less: "The date is under the limit that you set",
      max: "The date is over or equal to the limit that you set",
      min: "The date is under or equal to the limit that you set",
      strict: "Occurs when the input is not a Date type and convert is disabled"
    },
    function: {
      arity: "The number of arguments for the function doesn't match the required number",
      class: "The input is not a JavaScript class",
      maxArity: "The number of arguments for the function is over the required number",
      minArity: "The number of arguments for the function is under the required number"
    },
    number: {
      base: "The value is not a number or could not be cast to a number",
      greater: "The number is lower or equal to the limit that you set",
      infinity: "The number is Infinity or -Infinity",
      integer: "The number is not an integer",
      less: "The number is greater or equal to the limit that you set",
      max: "The number is greater than the limit that you set",
      min: "The number is lower than the limit that you set",
      multiple: "The number is not a multiple of the required number",
      negative: "The number is positive",
      port: "The number is not a valid port",
      positive: "The number is negative",
      precision: "The number has more decimal places than expected",
      ref: "The number is not a valid reference",
      safe: "The number is not a safe integer",
      sign: "The number is not of the required sign",
      unsafe: "The number is a safe integer"
    },
    object: {
      allowUnknown: "An unknown key was found in the object",
      and: "Some keys are missing in the object",
      assert: "The object did not pass the assertion test",
      base: "{label} is required",
      instance: "The object is not an instance of the required type",
      length: "The object does not have the required number of keys",
      max: "The object has more keys than the maximum allowed",
      min: "The object has less keys than the minimum allowed",
      missing: "Some keys are missing in the object",
      nand: "Some keys are present in the object",
      oxor: "Some keys are missing in the object",
      pattern: "The object has a key that did not match the required pattern",
      ref: "The object is not a valid reference",
      regex: {
        base: "The object has a key that did not match the required pattern",
        name: "The object has a key that did not match the required pattern",
        invert: {
          base: "{label} matches the excluded pattern",
          name: "{label} matches the excluded pattern"
        }
      },
      rename: {
        multiple: "The object has multiple keys when only one is allowed",
        override: "The object has a key that is not allowed to be overridden"
      },
      schema: "The object has a key that did not match the required schema",
      unknown: "An unknown key was found in the object",
      with: "Some keys are missing in the object",
      without: "Some keys are present in the object",
      xor: "Some keys are missing in the object"
    },
    string: {
      alphanum: "{label} contains characters that are not alphanumeric",
      base: "{label} is required",
      base64: "{label} is not a valid base64 encoded string",
      creditCard: "{label} is not a valid credit card number",
      dataUri: "{label} is not a valid data URI",
      domain: "{label} is not a valid domain",
      email: "{label} is not a valid email",
      notEmail: "{label} cannot be an email",
      empty: "Please enter your {label}",
      guid: "{label} is not a valid GUID",
      hex: "{label} is not a valid hexadecimal string",
      hexAlign: "{label} is not a valid hexadecimal string",
      hostname: "{label} is not a valid hostname",
      ip: "{label} is not a valid IP address",
      ipVersion: "{label} is not a valid IP address of the required version",
      isoDate: "{label} is not a valid ISO date",
      isoDuration: "{label} is not a valid ISO duration",
      length: "{label} is not of the required length",
      lowercase: "{label} contains uppercase characters",
      max: "{label} is longer than the maximum allowed length",
      min: "{label} is shorter than the minimum allowed length",
      normalize: "{label} is not in the required Unicode normalization form",
      pattern: {
        base: "{label} does not match the required pattern",
        name: "{label} does not match the required pattern",
        invert: {
          base: "{label} matches the excluded pattern",
          name: "{label} matches the excluded pattern"
        }
      },
      ref: "{label} is not a valid reference",
      regex: {
        base: "{label} does not match the required pattern",
        name: "{label} does not match the required pattern",
        invert: {
          base: "{label} matches the excluded pattern",
          name: "{label} matches the excluded pattern"
        }
      },
      token: "{label} is not a valid token",
      trim: "{label} contains leading or trailing whitespaces",
      uri: {
        base: "{label} is not a valid URI",
        customScheme: "{label} is not a valid URI",
        relativeOnly: "{label} is not a valid relative URI"
      },
      uppercase: "{label} contains lowercase characters"
    },
    symbol: {
      base: "{label} is required",
      map: "The value is not a valid Symbol"
    },
    otp: {
      required: "Please enter your {label}",
      invalid: "The {label} you have entered is invalid"
    },
    credentials: {
      invalid: "The credentials you have entered are invalid. Please check your credentials and try again."
    }
  },
  errors: {
    agent: {
      goToCrm: "Please log in to the CRM before attempting to log in again."
    },
    alertFromApiResponse: {
      not: {
        apiResponse: "An unexpected error has occured. Please try again later."
      },
      undefined: "Please try again later."
    },
    vueInjectionMissing: {
      title: "Application Error",
      text: "Application has not finished loading. Please refresh and try again."
    },
    httpCaught: {
      title: "Request Error",
      text: "An error has occured while processing your request. Please check your internet connection and try again."
    },
    invalidIdentityFeedback: {
      title: "System Error",
      text: "An error has occured while processing your request. Please try again later."
    },
    notYetImplemented: "This feature is not yet implemented",
    otp: {
      required: "You must re-submit this request with a valid Two-Factor Authentication code",
      invalid: "The Two-Factor Authentication code you have entered is invalid",
      retry: "Please wait until the next code is generated and try again"
    },
    credentials: {
      invalid: "The credentials you have entered are invalid. Please check your credentials and try again."
    },
    authenticated: {
      is: {
        title: "Active Session Detected",
        text: "You are logged in. Please log out before attempting this action."
      },
      not: "You must be logged in to access this feature"
    },
    clients: {
      max: "You cannot chat with more than 1 client in the same conversation."
    },
    not: {
      acceptable: "Your request could not be processed. Please check your request and try again."
    },
    participants: {
      valid: {
        none: "You do not have permission to chat with any of the selected participants. Please refresh and try again."
      }
    },
    operation: {
      failed: "The operation failed. Please try again later."
    },
    attach: {
      window: "This function is not available in this environment",
      filepicker: {
        title: "Unable to open file picker",
        text: "Please try from a different client or browser"
      },
      tooLargeFiles: {
        title: "Cannot Send Attachments",
        text: "One or more of the files you are trying to send is too large to be sent as an attachment. Please try again with smaller files."
      },
      unsupportedFiles: {
        title: "Cannot Send Attachments",
        text: "One or more of the files you are trying to send is not supported. Please try again with different files."
      }
    },
    chat: {
      send: {
        forbidden: {
          title: "Sending Failed",
          text: "This message was not allowed. Please check the contents of your message and try again."
        }
      },
      update: {
        forbidden: {
          title: "Edit Failed",
          text: "This message was not allowed to be edited. Please check the contents of your edit and try again."
        }
      },
      delete: {
        forbidden: {
          title: "Delete Failed",
          text: "You are not allowed to delete this message."
        }
      },
      message: {
        removedMalicious: {
          title: "Message Deleted",
          text: "A message which you sent was removed from the chat because it was flagged containing infected or malicious content."
        }
      }
    }
  },
  notices: {
    agent: {
      client: {
        assigned: {
          title: "New Contact Available",
          text: "{identifier} is now available in your contact list"
        },
        unassigned: {
          title: "Contact No Longer Available",
          text: "{identifier} is no longer available in your contact list. All conversations have been changed to read only."
        }
      }
    }
  }
};
const mAr = {
  general: {
    logo: "شعار {brand}",
    tradingAccount: "{brand} حساب التداول"
  },
  malarkeyLogin: {
    general: {
      login: "تسجيل الدخول",
      submit: "يُقدِّم"
    },
    agent: {
      hint: "الرجاء تسجيل الدخول باستخدام بيانات اعتماد وكيل {bold}.",
      mfaHint: "الرجاء إدخال رمز المصادقة الثنائية {bold} الخاص بك.",
      fields: {
        username: "{brand} البريد الإلكتروني لحساب التداول",
        password: "{brand} كلمة مرور حساب التداول"
      }
    },
    client: {
      hint: "يرجى تسجيل الدخول باستخدام بيانات اعتمادك {bold}.",
      mfaHint: "الرجاء إدخال رمز المصادقة الثنائية {bold} الخاص بك.",
      fields: {
        username: "{brand} اسم مستخدم الوكيل",
        password: "{brand} كلمة مرور الوكيل"
      }
    }
  }
};
const en = {
  $vuetify: en$1,
  ...mEn
};
const ar = {
  $vuetify: vAr,
  ...mAr
};
const messages = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ar,
  en
}, Symbol.toStringTag, { value: "Module" }));
export {
  ar as a,
  en as e,
  messages as m
};
//# sourceMappingURL=index-38c53cf2.mjs.map
